// Close the books API (/api/books-close, migration 20261206).
import apiClient from '../../../shared/services/apiClient';

export const booksCloseAPI = {
  overview: (businessId, through) => apiClient.get(`/books-close/${businessId}`, { params: through ? { through } : {} }),
  close: (businessId, data) => apiClient.post(`/books-close/${businessId}/close`, data),
  reopen: (businessId, data) => apiClient.post(`/books-close/${businessId}/reopen`, data),
  unlock: (businessId, data) => apiClient.post(`/books-close/${businessId}/unlock`, data),
  setPassword: (businessId, data) => apiClient.put(`/books-close/${businessId}/password`, data),
  addDelegate: (businessId, userId) => apiClient.post(`/books-close/${businessId}/delegates`, { user_id: userId }),
  removeDelegate: (businessId, userId) => apiClient.delete(`/books-close/${businessId}/delegates/${userId}`)
};

export default booksCloseAPI;